import { Box, Group, Stack, Text } from '@mantine/core'
import { IconClockCheck, IconPhoto, IconSettings, IconTool } from '@tabler/icons-react'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { RouterLink } from '../../../components/RouterLink'

export const Route = createFileRoute('/app/settings/branch-settings')({
  component: BranchSettingsLayout,
  beforeLoad: ({ location }) => {
    if (location.pathname === '/app/settings/branch-settings') {
      throw redirect({
        to: '/app/settings/branch-settings/general',
      })
    }
  },
})

function BranchSettingsLayout() {
  const navigationItems = [
    {
      path: '/app/settings/branch-settings/general',
      icon: IconSettings,
      label: 'General',
    },
    {
      path: '/app/settings/branch-settings/service-capabilities',
      icon: IconTool,
      label: 'Service capabilities',
    },
    {
      path: '/app/settings/branch-settings/business-hours',
      icon: IconClockCheck,
      label: 'Business hours',
    },
    {
      path: '/app/settings/branch-settings/branch-identity',
      icon: IconPhoto,
      label: 'Branch identity',
    },
  ]

  return (
    <Stack>
      <Group align="flex-start" gap="xl">
        <Box style={{ minWidth: 200 }}>
          <Stack gap="xs">
            {navigationItems.map((item) => (
              <RouterLink
                key={item.path}
                to={item.path}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  color: 'inherit',
                  transition: 'background-color 0.2s',
                }}
                activeProps={{
                  style: {
                    backgroundColor: 'var(--mantine-color-orange-1)',
                    color: 'var(--mantine-color-orange-8)',
                  },
                }}
              >
                <item.icon size={20} />
                <Text size="sm" fw={500}>
                  {item.label}
                </Text>
              </RouterLink>
            ))}
          </Stack>
        </Box>

        <Box style={{ flex: 1 }}>
          <Box maw="750px" mx="auto">
            <Outlet />
          </Box>
        </Box>
      </Group>
    </Stack>
  )
}
